import { computed, type Ref } from 'vue'
import type { Product } from '@scayle/storefront-nuxt'

const isValueEmpty = (value: unknown): boolean => {
  if (!value) {
    return true
  }
  if (Array.isArray(value)) {
    return value.length === 0
  }
  if (typeof value === 'object') {
    return Object.keys(value).length === 0
  }
  return false
}

const formatAttribute = (attribute: any): string[] => {
  if (!attribute || !attribute.values) {
    return []
  }

  // AdvancedAttributes with fieldSet
  if (Array.isArray(attribute.values) && attribute.values[0]?.fieldSet) {
    return attribute.values
      .flatMap(
        (val: any) =>
          val.fieldSet?.flatMap((fs: any[]) =>
            fs.map((entry) => entry?.label || entry?.value),
          ) ?? [],
      )
      .filter(Boolean)
  }

  // Regular attributes
  const values = Array.isArray(attribute.values)
    ? attribute.values
    : [attribute.values]

  return values.map((val: any) => val?.label || val?.value).filter(Boolean)
}

export const useProductAttributes = (
  product: Ref<Product>,
  schema: string[],
) => {
  return computed(() =>
    schema
      .map((key) => {
        const advAttr = product.value.advancedAttributes?.[key]
        const attr = product.value.attributes?.[key]

        const chosenAttr = !isValueEmpty(advAttr?.values) ? advAttr : attr

        if (!chosenAttr || isValueEmpty(chosenAttr.values)) {
          return null
        }

        return {
          key,
          label: chosenAttr.label || key,
          values: formatAttribute(chosenAttr),
        }
      })
      .filter(Boolean),
  )
}
